/* 22.08.2026: auskommentierte Altfassung entfernt; der fruehere
   document-resize-Listener war wirkungslos (resize feuert nur auf window)
   und wurde ersatzlos gestrichen. */
(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		updatethumbnail(true);
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	swiperInit();
})();
